(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-player-competitions.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-player-competitions.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const fetchPlayerCompetitions = svs.components.marketplaceCompetition.services.actions.playerCompetitionActions.fetchPlayerCompetitions;
const selectPlayerCompetitions = svs.components.marketplaceCompetition.services.selectors.playerCompetitionSelectors.selectPlayerCompetitions;
const userSession = svs.core.userSession;
const usePlayerCompetitions = options => {
  const _ref = options || {},
    competitionId = _ref.competitionId,
    _ref$forceFetch = _ref.forceFetch,
    forceFetch = _ref$forceFetch === void 0 ? false : _ref$forceFetch,
    _ref$isActiveOnly = _ref.isActiveOnly,
    isActiveOnly = _ref$isActiveOnly === void 0 ? true : _ref$isActiveOnly;
  const dispatch = useDispatch();
  const playerCompetitions = useSelector(selectPlayerCompetitions);
  useEffect(() => {
    if (forceFetch || !userSession.isAnonymous()) {
      dispatch(fetchPlayerCompetitions({
        competitionId,
        isActiveOnly
      }));
    }
  }, [competitionId, dispatch, forceFetch, isActiveOnly]);
  return playerCompetitions;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.usePlayerCompetitions', usePlayerCompetitions);

 })(window);